import React, { createContext, useState } from 'react';

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [sidebarModules, setSidebarModules] = useState([]);

  const updateSidebarModules = (modules) => {
    setSidebarModules(modules);
  };

  return (
    <SidebarContext.Provider value={{ sidebarModules, updateSidebarModules }}>
      {children}
     
    </SidebarContext.Provider>
  );
};
